import { Post } from "../app_services/ApiService";
import { Loading, AlertError, AlertInfo, AlertClose } from "../app_services/AlertService";

export const get_main_user_data = async (form, navigation, setUserData) => {
    try {
        // Loading()
        let respon = await Post(`mkmedical-api/customer/reward-customer-line-account/get-mobile-member-by-line-userid`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }
        /*
                setUserData({
                    data_main: respon.data.data,
                    data_store: respon.data.data_store
                })*/
        // if (respon.data.status !== '1') {
        //     AlertInfo('', respon.data.message);
        //     navigation('/login')
        //     return;
        // }
        // setUserData(respon.data.data)
        // AlertClose();

        let data = null
        if (respon.data.data) {
            data = {
                data_main: respon.data.data,
                data_store: respon.data.data_store
            }
        }
        setUserData(data)
        return data
    } catch (error) {
        console.log(error)
        AlertError();
    }
};

